<template>
  <div style="position: relative">
    <div class="basket-wrapper">
      <template v-if="!cartLineItems?.length">
        <wa-button slot="trigger" appearance="plain" size="m" class="cartButton">
          <PhShoppingBag color="white" :size="24" />
        </wa-button>
      </template>

      <template v-else>
        <wa-button
          slot="trigger"
          appearance="plain"
          size="m"
          class="cartButton"
          @click="uiStore.showCart = true"
        >
          <PhShoppingBag color="white" :size="24" />
          <wa-badge variant="brand" pill>{{ cartLineItems?.length }}</wa-badge>
        </wa-button>
      </template>
    </div>
  </div>
</template>

<script setup>
import '@awesome.me/webawesome/dist/components/button/button.js'
import '@awesome.me/webawesome/dist/components/icon/icon.js'
import '@awesome.me/webawesome/dist/components/drawer/drawer.js'
import '@awesome.me/webawesome/dist/components/badge/badge.js'
import { PhShoppingBag } from '@phosphor-icons/vue'
import { useUiStore } from '@/stores/ui.js'
import { useCart } from '@/composables/useCart.js'

const uiStore = useUiStore()
const { cartLineItems } = useCart()
</script>

<style>
.cartButton wa-badge {
  /* Web Awesome pins slotted badges to the right edge and shifts them by half their width; with
     the app's left offset that stretched the badge into a wide pill. Shoelace painted the inner
     part instead: a round badge whose left edge sits 33px into the button, so pin it there. */
  left: 33px;
  right: auto;
  top: 10px;
  translate: 0 -50%;
  background-color: white;
  border-color: white;
  color: black;
  padding: 2px 5px;
}

.basket-wrapper {
  wa-button {
    /* Web Awesome pads the button base, Shoelace padded the label */
    &::part(base) {
      padding: 0 var(--wa-space-xs) 0 var(--wa-space-l);
    }

    &::part(label) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
